import { PassouFalhouEnum } from '@atendimento/detail/soap/objetivo/puericultura/mchat-rf/consulta-seguimento/enums-consultaSeguimento'
import {
  ConsultaSeguimentoPergunta16ExemplosEnum,
  ConsultaSeguimentoPergunta16Model,
} from '@atendimento/detail/soap/objetivo/puericultura/mchat-rf/consulta-seguimento/perguntas/consulta-seguimento-pergunta-16/model-consultaSeguimentoPergunta16'
import { MchatRfAplicacaoQueryModel } from '@atendimento/detail/soap/objetivo/puericultura/mchat-rf/model-mChatRf'
import { booleanToSimNaoEnum } from 'components/form'
import { MChatPerguntaEnum } from 'graphql/types.generated'

import { convertToPassouFalhou, HISTORICO_MCHAT_CALCULATION_STATUS } from '../utils-HistoricoMchatRf'

interface HistoricoMChatRfPergunta16Model {
  header: MchatRfAplicacaoQueryModel
  exemplosPassou: MchatRfAplicacaoQueryModel[]
  exemplosFalhou: MchatRfAplicacaoQueryModel[]
  frequencia: MchatRfAplicacaoQueryModel | undefined
  model: ConsultaSeguimentoPergunta16Model
}

export const convertAplicacaoPergunta16 = (
  aplicacoes: ReadonlyArray<MchatRfAplicacaoQueryModel>
): HistoricoMChatRfPergunta16Model | null => {
  const header = aplicacoes.find((aplicacao) => aplicacao.pergunta === MChatPerguntaEnum.PERGUNTA_16_01)
  const exemplosPassou = aplicacoes.filter((aplicacao) => PERGUNTA_16_EXEMPLOS_PASSOU.includes(aplicacao.pergunta))
  const exemplosFalhou = aplicacoes.filter((aplicacao) => PERGUNTA_16_EXEMPLOS_FALHOU.includes(aplicacao.pergunta))
  const frequencia = aplicacoes.find((aplicacao) => aplicacao.pergunta === MChatPerguntaEnum.PERGUNTA_16_07)

  if (header === undefined) return null

  return {
    header,
    exemplosPassou,
    exemplosFalhou,
    frequencia,
    model: {
      status: HISTORICO_MCHAT_CALCULATION_STATUS,
      PERGUNTA_16_HEADER: booleanToSimNaoEnum(header.stPassou),
      PERGUNTA_16_EXEMPLOS: {
        PASSOU: convertAplicacoesToExemplos(exemplosPassou),
        FALHOU: convertAplicacoesToExemplos(exemplosFalhou),
      },
      PERGUNTA_16_FREQUENCIA: convertToPassouFalhou(frequencia?.stPassou),
    },
  }
}

const convertAplicacoesToExemplos = (
  aplicacoes: ReadonlyArray<MchatRfAplicacaoQueryModel>
): Record<ConsultaSeguimentoPergunta16ExemplosEnum, ReturnType<typeof booleanToSimNaoEnum>> =>
  aplicacoes.reduce<Record<ConsultaSeguimentoPergunta16ExemplosEnum, ReturnType<typeof booleanToSimNaoEnum>>>(
    (acc, aplicacao) => {
      const pergunta = MAP_PERGUNTA_TO_ENUM[aplicacao.pergunta]

      if (pergunta) {
        acc[pergunta] = booleanToSimNaoEnum(aplicacao.stPassou)
      }

      return acc
    },
    { ...EMPTY_EXEMPLOS }
  )

export const formatPergunta16Frequencia = (value: boolean | null | undefined): string | undefined => {
  const passouFalhou = convertToPassouFalhou(value)

  if (passouFalhou === PassouFalhouEnum.PASSOU) return 'Exemplos PASSOU'
  if (passouFalhou === PassouFalhouEnum.FALHOU) return 'Exemplos FALHOU'
}

const PERGUNTA_16_EXEMPLOS_PASSOU = [
  MChatPerguntaEnum.PERGUNTA_16_02,
  MChatPerguntaEnum.PERGUNTA_16_03,
  MChatPerguntaEnum.PERGUNTA_16_04,
]

const PERGUNTA_16_EXEMPLOS_FALHOU = [MChatPerguntaEnum.PERGUNTA_16_05, MChatPerguntaEnum.PERGUNTA_16_06]

const EMPTY_EXEMPLOS: Record<ConsultaSeguimentoPergunta16ExemplosEnum, undefined> = {
  [ConsultaSeguimentoPergunta16ExemplosEnum.OLHA_PARA_O_QUE_VOCE_ESTA_OLHANDO]: undefined,
  [ConsultaSeguimentoPergunta16ExemplosEnum.APONTA_PARA_O_QUE_VOCE_ESTA_OLHANDO]: undefined,
  [ConsultaSeguimentoPergunta16ExemplosEnum.OLHA_AO_REDOR_PARA_O_QUE_VOCE_ESTA_OLHANDO]: undefined,
  [ConsultaSeguimentoPergunta16ExemplosEnum.NAO_REPARA_EM_VOCE]: undefined,
  [ConsultaSeguimentoPergunta16ExemplosEnum.OLHA_PARA_SEU_ROSTO]: undefined,
}

const MAP_PERGUNTA_TO_ENUM: Partial<Record<MChatPerguntaEnum, ConsultaSeguimentoPergunta16ExemplosEnum>> = {
  [MChatPerguntaEnum.PERGUNTA_16_02]: ConsultaSeguimentoPergunta16ExemplosEnum.OLHA_PARA_O_QUE_VOCE_ESTA_OLHANDO,
  [MChatPerguntaEnum.PERGUNTA_16_03]: ConsultaSeguimentoPergunta16ExemplosEnum.APONTA_PARA_O_QUE_VOCE_ESTA_OLHANDO,
  [MChatPerguntaEnum.PERGUNTA_16_04]:
    ConsultaSeguimentoPergunta16ExemplosEnum.OLHA_AO_REDOR_PARA_O_QUE_VOCE_ESTA_OLHANDO,
  [MChatPerguntaEnum.PERGUNTA_16_05]: ConsultaSeguimentoPergunta16ExemplosEnum.NAO_REPARA_EM_VOCE,
  [MChatPerguntaEnum.PERGUNTA_16_06]: ConsultaSeguimentoPergunta16ExemplosEnum.OLHA_PARA_SEU_ROSTO,
}
